<template>
  <div>
    <section class="hero">
      <h2 class="hero-title">{{ $t('hero.title') }}</h2>
      <p class="hero-subtitle">{{ $t('hero.subtitle') }}</p>
      <button class="hero-button" @click="handleExperienceClick">{{ $t('hero.tryNow') }}</button>
    </section>

    <!-- Features Section -->
    <section id="features" class="features">
      <h2 class="features-title">{{ $t('hero.features.title') }}</h2>
      <div class="features-grid">
        <div class="feature-card" v-for="feature in getFeatures" :key="feature.id">
          <div class="feature-icon">{{ feature.icon }}</div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </section>

    <!-- Reviews Section -->
    <section id="reviews" class="reviews">
      <h2 class="reviews-title">{{ $t('hero.reviews.title') }}</h2>
      <div class="reviews-grid">
        <div class="review-card" v-for="review in getReviews" :key="review.id">
          <p class="review-text">{{ review.text }}</p>
          <p class="review-author">- {{ review.author }}</p>
        </div>
      </div>
    </section>

    <!-- Modal -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p>
          {{ $t('hero.loginModal.title') }}
          <br />
          {{ $t('hero.loginModal.subtitle') }}
        </p>
        <div class="modal-buttons">
          <router-link to="/square" class="modal-button">{{ $t('hero.loginModal.goToSquare') }}</router-link>
          <router-link to="/login" class="modal-button">{{ $t('hero.loginModal.login') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      showModal: false,
      navigating: false,
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem("access_token");
    },
    getFeatures() {
      return [
        {
          id: 'video',
          icon: "🎬",
          title: this.$t('hero.features.videoGeneration.title'),
          description: this.$t('hero.features.videoGeneration.description'),
        },
        {
          id: 'chart',
          icon: "🗺️",
          title: this.$t('hero.features.chartAnalysis.title'),
          description: this.$t('hero.features.chartAnalysis.description'),
        },
        {
          id: 'ppt',
          icon: "📥",
          title: this.$t('hero.features.pptDownload.title'),
          description: this.$t('hero.features.pptDownload.description'),
        },
      ];
    },
    getReviews() {
      return [
        {
          id: 'student1',
          text: this.$t('hero.reviews.student1.text'),
          author: this.$t('hero.reviews.student1.author'),
        },
        {
          id: 'student2',
          text: this.$t('hero.reviews.student2.text'),
          author: this.$t('hero.reviews.student2.author'),
        },
        {
          id: 'professor',
          text: this.$t('hero.reviews.professor.text'),
          author: this.$t('hero.reviews.professor.author'),
        },
      ];
    }
  },
  methods: {
    async handleExperienceClick() {
      if (this.navigating) return;
      this.navigating = true;

      if (!this.isLoggedIn) {
        this.showModal = true;
        this.navigating = false;
      } else if (this.$route.path !== "/studio") {
        try {
          await this.$router.push("/studio");
        } catch (error) {
          console.error("导航错误:", error);
        } finally {
          this.navigating = false;
        }
      } else {
        this.navigating = false;
      }
    },
  },
};
</script>

<style scoped>
.hero {
  padding: 4rem 2rem;
  text-align: center;
  background-color: #f8fafc;
}

.hero-title {
  font-size: 2.5rem;
  color: #1e293b;
  margin-bottom: 1.5rem;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
}

.hero-button {
  display: inline-block;
  margin-top: 2rem;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  color: #fff;
  background-color: #3b82f6;
  border-radius: 0.375rem;
  text-decoration: none;
  transition: background-color 0.3s;
}

.hero-button:hover {
  background-color: #2563eb;
}

.features {
  padding: 1rem 2rem 4rem 2rem;
  background-color: #f8fafc;
}

.features-title {
  text-align: center;
  font-size: 2rem;
  color: #1e293b;
  margin-bottom: 3rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.feature-card h3 {
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.feature-card p {
  color: #64748b;
}

.reviews {
  padding: 2rem;
  background-color: #f8fafc;
}

.reviews-title {
  text-align: center;
  font-size: 2rem;
  color: #1e293b;
  margin-bottom: 2rem;
}

.reviews-grid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
}

.review-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

.review-text {
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.review-author {
  color: #64748b;
  font-style: italic;
}

.modal {
  display: flex;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
  width: 90%;
}

.modal-buttons {
  margin-top: 1rem;
}

.modal-button {
  margin: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  text-decoration: none;
}

.modal-button:hover {
  background-color: #2563eb;
}

.close {
  cursor: pointer;
  float: right;
  font-size: 1.5rem;
}
</style>
